import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';

import AnimatedScreenWrapper from '../../Components/AnimatedScreenWrapper';
import OnboardingNavButtons from '../../Components/OnboardingNavButtons';
import { PreSignupFlowContext } from '../../PreSignupProvider';
import { TopContent, Wrapper } from './styles';

const TransitionScreen = () => {
	const { formatMessage } = useIntl();
	const { ActiveScreen, nextScreen, skipToEnd } = useContext(PreSignupFlowContext);
	const { transitionType, analyticsName, isDark, renderChildren } = ActiveScreen;
	const { logEvent } = useAnalytics();

	async function onContinue(): Promise<void> {
		logEvent({
			eventName: 'FTUE : Transition : Proceeded',
			eventProps: {
				transition_type: transitionType as string,
			},
		});
		nextScreen();
	}

	async function onCustomSkip(): Promise<void> {
		logEvent({
			eventName: `${analyticsName} : Skipped`,
			eventProps: {
				transition_type: transitionType as string,
			},
		});
		window.scrollTo(0, 0);
		skipToEnd();
	}

	return (
		<Wrapper isDark={isDark}>
			<AnimatedScreenWrapper>
				{renderChildren && <TopContent>{renderChildren(formatMessage)}</TopContent>}
				<OnboardingNavButtons
					onContinue={onContinue}
					onCustomSkip={onCustomSkip}
					focusRingVariant={isDark ? 'light' : 'dark'}
					continueButtonStyle={{
						backgroundColor: 'white',
						textColor: 'gray7',
					}}
				/>
			</AnimatedScreenWrapper>
		</Wrapper>
	);
};

export default TransitionScreen;
